import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export default (articles => articles ? articles.get('results').map(article => {
  const title = article.get('title');
  const language = article.get('language');
  const isTranslation = article.get('isTranslation');
  const version = article.get('version');
  const displayTitle = isTranslation && language && version === '3' ? `${title} (${language})` : title;
  return {
    text: displayTitle,
    value: article.get('id'),
    help: /*#__PURE__*/_jsx(TruncateString, {
      children: article.get('articleSummary')
    }),
    version,
    language,
    isTranslation
  };
}).toArray() : []);